import React, {Component} from 'react';
import './AnnouncementTicker.css';
import {checkHasMembership_, request} from '../../util/APIUtils';
import {API_BASE_URL} from "../../constants";
import {showAxiosError} from "../../util/Helpers";
import {Link} from "react-router-dom";


class AnnouncementTicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            currentUser: this.props.currentUser,
            userAnnouncements:[],
        };
        this.listUserAnnouncements=this.listUserAnnouncements.bind(this);
    }

    componentDidMount() {
       this.listUserAnnouncements();
    }

    listUserAnnouncements() {
        let self = this;
        //let userId=this.state.currentUser.id;
        let params = {
            url: API_BASE_URL+"/announcement/forUser" ,
            method: "get",
        };
        request(params)
            .then(function (response) {
                let userAnnouncements = response.data;
                self.setState({
                    userAnnouncements,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    render() {
        return (
            <div className="home-container">
                <div className="page-content">
                    <div className="marquee">
                        <p>
                            <ul style={{display: "flex", flexDirection: "row", flexWrap: "nowrap"}}>
                                {this.state.userAnnouncements.map((announcement)=>
                                <li key={announcement.id} className="label-blue">
                                    <Link to={{pathname:'/announcementItem/'+announcement.id , selectedAnnouncement:{announcement}}} >
                                        <img className="popup-announcement-toggle__icon" src={process.env.REACT_APP_CONTEXT_NAME + "/image/icon.png"}/>
                                        {announcement.title}
                                    </Link>
                                </li>
                                )}
                            </ul>
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    checkMemberShip(){
        const userId = this.props.currentUser.id;
        checkHasMembership_(userId)
            .then(response => {
                if(response.data.available===true){
                    this.setState({
                        hasMembership:true
                    });
                }
            }).catch(error => {
            this.setState({
                hasMembership:false
            });
        });
    }

}

export default AnnouncementTicker;



// WEBPACK FOOTER //
// ./src/page/announcement/AnnouncementTicker.js